import { useContext } from "react";
import { ApartmentViewContext } from "../context/ApartmentViewContext";
import {
	insolationModeName,
	isometricModeName,
} from "../context/contextStrings";
import SunPathRenderer from "./SunPathRenderer";
import styles from "../../../styles/aprt.module.scss";

function CardinalsRenderer({ viewerMode, apartmentData }) {
	const { insolationAngle, isometricAngle } = useContext(ApartmentViewContext);
	const isItInsolationMode = viewerMode === insolationModeName;
	const isItIsometricMode = viewerMode === isometricModeName;

	const sunLightRanges = apartmentData.sun_light_ranges || [];

	const angle = insolationAngle;
	const width = 680;
	const height = width;
	const padding = 36;
	const textOffset = 18;

	const centerX = width / 2;
	const centerY = height / 2;

	const commonTextProps = {
		stroke: "white",
		strokeWidth: "0.75",
		textAnchor: "middle",
		dominantBaseline: "middle",
	};

	return (
		<svg
			viewBox={`0 0 ${width} ${height}`}
			className={styles.overlaySVG}
			width={"100%"}
			height={"100%"}
			>
			{isItInsolationMode && (
				<SunPathRenderer
					width={width}
					height={height}
					padding={padding}
					angle={angle}
					sunLightRanges={sunLightRanges}
				/>
			)}
			<g 
			id="cardinals"
			transform={isItIsometricMode 
				? `rotate(${isometricAngle}, ${centerX}, ${centerY})`
				: "rotate(0)"}
			>
				{/* Północ */}
				<text
					{...commonTextProps}
					x={centerX}
					y={1.5 * textOffset}
					transform={
						isItIsometricMode
							? `rotate(${-isometricAngle}, ${centerX}, ${1.5 * textOffset})`
							: "rotate(0)"
					}
				>
					<tspan className={styles.cardinalTag} title="North">
						<title>Północ</title>
						{/*TODO: use locales/ translation.json*/}
						{`N`}
					</tspan>
				</text>

				{/* Wschód */}
				<text
					{...commonTextProps}
					x={width - textOffset}
					y={centerY}
					transform={
						isItIsometricMode
							? `rotate(${-isometricAngle}, ${width - textOffset}, ${
									centerY
							  })`
							: "rotate(0)"
					}
				>
					<tspan className={styles.cardinalTag} title="East">
						<title>Wschód</title>
						{/*TODO: use locales/ translation.json*/}
						{`E`}
					</tspan>
				</text>

				{/* Południe */}
				<text
					{...commonTextProps}
					x={centerX}
					y={height - textOffset}
					transform={
						isItIsometricMode
							? `rotate(${-isometricAngle}, ${centerX}, ${
									height - textOffset
							  })`
							: "rotate(0)"
					}
				>
					<tspan className={styles.cardinalTag} title="South">
						<title>Południe</title>
						{/*TODO: use locales/ translation.json*/}
						{`S`}
					</tspan>
				</text>

				{/* Zachód */}
				<text
					{...commonTextProps}
					x={textOffset}
					y={centerY}
					transform={
						isItIsometricMode
							? `rotate(${-isometricAngle}, ${textOffset}, ${centerY})`
							: "rotate(0)"
					}
				>
					<tspan className={styles.cardinalTag} title="West">
						<title>Zachód</title>
						{/*TODO: use locales/ translation.json*/}
						{`W`}
					</tspan>
				</text>
			</g>
		</svg>
	);
}

export default CardinalsRenderer;
